<template>
  <section class="container Card">
    <!-- contact footer -->
    <div class="row Card-footer">
      <div class="col-lg-7">
        <h4>Email: </h4>
        <p><a class="linkInline linkInline--teal" href="mailto:sales@ideum.com">sales@ideum.com</a></p>
        <h4 class="ml-lg-5 ml-sm-3">Phone: </h4>
        <p><a class="linkInline linkInline--teal" href="tel:1-505-792-1110">(505) 792-1110 ext. 1</a></p>
      </div>
      <div class="col-lg-4 ml-lg-auto text-lg-right">
        <h4>Follow us:</h4>
        <ul>
          <li class="Card-footer-socialIcon">
            <a href="https://twitter.com/ideum?lang=en" target="_blank" title="Ideum on Twitter" rel="noopener">
              <icon name="twitter"/>
            </a>
          </li>
          <li class="Card-footer-socialIcon">
            <a href="https://www.facebook.com/ideum/" target="_blank" title="Ideum on Facebook" rel="noopener">
              <icon name="facebook"/>
            </a>
          </li>
          <li class="Card-footer-socialIcon">
            <a href="https://www.linkedin.com/company/ideum/" target="_blank" title="Ideum on LinkedIn" rel="noopener">
              <icon name="linkedin"/>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="row Card-body gradient--blue--topo">
      <div class="col-12 text-center">
        <h2 class="Card-title">Why Choose Us</h2>
      </div>
      <div class="col-md-5 offset-md-1 Card-main">
        <p class="mb-5 mb-md-0">
          Ideum multitouch displays use LG 4K Ultra HD commercial screens and advanced touch technology from 3M™ in a rugged all-aluminum case. Our interactive displays are used in architecture and design, exhibits, construction, trade shows, retail, control rooms, and other settings.
        </p>
      </div>
      <div class="col-md-5 Card-aside">
        <ul>
          <li class="Card-list-item">
            <h3 class="Card-heading">The Highest Quality</h3>
            <p>Ideum Presenter multitouch screens with 3M touch technology have greater precision and responsiveness than other large touch displays.</p>
          </li>
          <li class="Card-list-item">
            <h3 class="Card-heading">Packed with Power</h3>
            <p>We have optional, custom built, small-form factor computers with full NVDIA graphics cards.</p>
          </li>
          <li class="Card-list-item">
            <h3 class="Card-heading">Versatility</h3>
            <p>Our motorized stands with casters provide flexibility allowing for a variety of uses from collaboration to presentation.</p>
          </li>
          <li class="Card-list-item">
            <h3 class="Card-heading">The Ultimate Win 10 Platform</h3>
            <p>Touch-centric applications including AEC software can run seamlessly on our powerful Windows systems.</p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/twitter'
import 'vue-awesome/icons/facebook'
import 'vue-awesome/icons/linkedin'

export default {
  components: {
    Icon
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/styles/_variables.scss';

.Card {
  color: $colorWhite;
  font-family: 'Poppins', sans-serif;
  margin-top: -75px;
  @media screen and (min-height: 500px) {
    margin-top: -150px;
  }
  @media screen and (min-width: $grid-md) and (min-height: 960px) {
    margin-top: -200px;
  }
  @media screen and (min-width: $grid-lg) and (min-height: 1200px){
    margin-top: -300px;
  }
}

.Card-aside {
  text-align: center;
  @media screen and (min-width: $grid-md) {
    padding-left: 3.5em;
    text-align: left;
  }
  @media screen and (min-width: $grid-sm) {
    padding-right: 2em;
    padding-left: 2em;
  }
}

.Card-body {
  box-shadow: 0px 0px 60px 10px rgba(0, 0, 0, 0.25);
  padding-bottom: 4em;
}

.Card-footer {
  font-weight: 500;
  padding-bottom: 1em;
  & h4, p, li, ul {
    display: inline-block;
  }
  @media screen and (min-width: $grid-sm) {
    font-size: 1.25em;
  }
}

.Card-footer-socialIcon {
  cursor: pointer;
  margin-left: 1em;
  transition: $transitionPrimary;
  vertical-align: middle;
  &:hover {
    color: $colorBlue;
  }
  & a {
    color: inherit;
  }
}

.Card-heading {
  font-size: 1.4em;
}

.Card-list-item {
  margin-bottom: 2em;
}

.Card-main {
  display: flex;
  flex-direction: column;
  
  font-weight: 600;
  justify-content: center;
  text-align: center;
  @media screen and (min-width: $grid-lg) {
    font-size: 1.75em;
  }
  @media screen and (min-width: $grid-md) {
    font-size: 1.5em;
    text-align: right;
  }
}

.Card-title {
  font-size: 1em;
  margin: 3em 0;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Card.vue